<template>
  <div class="pa-4">
    <content-pack-sections :item="item" :is-loading="isLoading" @update:item="onUpdateItem" />
  </div>
</template>

<script>
import ContentPackSections from '@/views/contentPacks/partials/ContentPackSections.vue'

export default {
  components: {
    ContentPackSections,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onUpdateItem = updatedItem => {
      emit('save', updatedItem)
    }

    return {
      onUpdateItem,
    }
  },
}
</script>
